module.exports = __webpack_public_path__ + "fonts/31D5D3_0_0.woff2";